export default "__VITE_ASSET__CoGIwLyo__"